<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span><a id="page_xi"></a><a id="page_1">PART ONE</a></span></p><a id="page_1">
<p class="part-title"><span>The President</span></p>
<p class="part-sub"><span><i>If we do not know courage</i></span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?153b14fe